const en_common_report = {

}

export default en_common_report;